import { NoticeTopBanner } from 'noddi-web';
import { getNoticeBannerTranslations } from '../../utils/commonTranslations';
import { useCustomerNotices } from './useCustomerNotices';

/** Top-of-page notices for this brand. */
export const CustomerNoticeTopBanner = () => {
  const { isBrandPending, error, top } = useCustomerNotices();

  if (isBrandPending || error) {
    return null;
  }

  return <NoticeTopBanner notices={top} translations={getNoticeBannerTranslations()} />;
};
